/**
 * The product's name and mark.
 *
 * The mark is two ledger lines and a tick: figures, checked. It is drawn
 * here rather than loaded from a file, so it is sharp at every size and
 * takes its colours from where it sits -- pine on paper, brass on the dark
 * sidebar. `public/favicon.svg` is the same drawing; change both together.
 *
 * The styles are inline on purpose: this is the first thing on screen
 * while the application loads, before any stylesheet has arrived.
 */
export const BRAND_NAME = 'TaxNexa'

const PINE = '#0f5a4b'
const PINE_DEEP = '#10231f'
const BRASS = '#e3b45c'
const INK = '#17211e'

export function BrandMark({ onDark = false, size = 28 }) {
  const stroke = onDark ? PINE_DEEP : '#ffffff'

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      aria-hidden="true"
      focusable="false"
      style={{ display: 'block', flex: '0 0 auto' }}>
      <rect width="32" height="32" rx="8" fill={onDark ? BRASS : PINE} />
      <path
        d="M8.5 10.5h15M8.5 15.5h8"
        stroke={stroke}
        strokeWidth="2.2"
        strokeLinecap="round"
        opacity="0.6"
      />
      <path
        d="M12.5 21.2l3.4 3.3 7.6-9"
        fill="none"
        stroke={stroke}
        strokeWidth="2.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default function Brand({ onDark = false, size = 22, markOnly = false, style }) {
  return (
    <span
      aria-label={BRAND_NAME}
      style={{
        alignItems: 'center',
        color: onDark ? '#ffffff' : INK,
        display: 'inline-flex',
        fontFamily: '"Source Serif 4 Variable", "Source Serif 4", Georgia, serif',
        fontSize: size,
        fontWeight: 600,
        gap: Math.round(size * 0.42),
        letterSpacing: '-0.015em',
        lineHeight: 1.1,
        whiteSpace: 'nowrap',
        ...style
      }}>
      <BrandMark onDark={onDark} size={Math.round(size * 1.3)} />
      {!markOnly && (
        <span>
          Tax<span style={{ color: onDark ? BRASS : PINE }}>Nexa</span>
        </span>
      )}
    </span>
  )
}
